// The links of Firebase's emails. A project has one action URL for every
// email template (HANDOFF.md, step F7), and it points at the app's
// new-password screen. Only the reset link is the app's to handle; the
// others, "recoverEmail" first (the owner's one way to undo a change of
// her email), go on to Firebase's own page, which knows them all.

export type ActionLink =
  | { kind: "reset"; code: string }
  /** Firebase's handler on the project's auth domain, with the link's whole query. */
  | { kind: "firebase"; url: string }
  | { kind: "invalid" };

/** What the link in the address bar is; `authDomain` is the app's own Firebase config, so the hand-off goes nowhere else. */
export function readActionLink(search: string, authDomain: string | undefined): ActionLink {
  const params = new URLSearchParams(search);
  const mode = params.get("mode");
  const code = params.get("oobCode");
  if (!mode || !code) return { kind: "invalid" };
  if (mode === "resetPassword") return { kind: "reset", code };
  // A blank config (HANDOFF.md, step F5) has no handler to send it to.
  if (!authDomain) return { kind: "invalid" };
  return { kind: "firebase", url: `https://${authDomain}/__/auth/action?${params.toString()}` };
}
